import $ from 'jquery';
import UIkit from 'uikit';

$(document).ready(function($) {
    $('.js-mach-open').click(function(){
        const item = $(this).data('mach-item');
        UIkit.slider('.js-mach-slider').show(item);
    });
});